import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import React, { useEffect, useState } from 'react'
import {usePut,useCurrent} from '../../hooks/'
import { MwButton, MwSpinnerButton } from '../../components/ui'
import { useDispatch } from 'react-redux'
import {updateSettings} from '../../store/settingSlice'
import SettingListItem from '../../components/settings/SettingListItem'
import { useTranslation } from 'react-i18next'
import { arrayToObjKeyValue } from '../../utils/global.js'

const CENTRAL_SETTINGS_SCOPE = 'global';

const GeneralSettings = ({refreshTenant,filterDefineSetting}) => {
    const dispatch = useDispatch();
    const {data,loading,putData} = usePut()
    const {currentCompanyId,currentTenantId,currentSettings,currentLangId} = useCurrent();
    const SETTING_GENERAL = currentSettings?.generalSettings;
    const [generalSetting,setGeneralSetting] = useState(SETTING_GENERAL || {})
    const [t] = useTranslation('global')

    const generalSettingArray = Object.entries(generalSetting || {});

    const generalSettingList =  generalSettingArray.map(([settingName,settingValue]) =>(
        <SettingListItem
            key={settingName}
            settingName = {settingName}
            settingValue = {settingValue}
            filterDefineSetting = {filterDefineSetting}
            setGeneralSetting = {setGeneralSetting}
            generalSetting = {generalSetting}
            currentLangId = {currentLangId}
            readOnly={settingName === 'DEFAULT_LANG'}
            />
    ));

    useEffect(()=>{
        if (SETTING_GENERAL) {
            setGeneralSetting(Array.isArray(SETTING_GENERAL) ? arrayToObjKeyValue(SETTING_GENERAL) : SETTING_GENERAL);
        }
        if(data){
            refreshTenant();
        }
    },[data, SETTING_GENERAL]);

    const saveHandler = async() => {
        try {
            const _data = {
                tenantId: currentTenantId,
                companyId: currentCompanyId,
                scope: CENTRAL_SETTINGS_SCOPE,
                data: {
                    invoiceSettings: currentSettings?.invoiceSettings || {},
                    generalSettings: generalSetting,
                    quoteSettings: currentSettings?.quoteSettings || {}
                }
            };
            
            await putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`, _data);
            
            dispatch(updateSettings({
                typeSetting: 'general',
                value: generalSetting
            }));
            
            await refreshTenant();
            
        } catch (error) {
            console.error('Error saving settings:', error);
        }
    }

    if (!generalSettingArray.some(([name]) => name !== 'DEFAULT_LANG')) {
        return <SettingsEmptyState title={t('setting.generalSettings')} />;
    }

    return (
        <div className="settings-editable-page">
            <div className='flex justify-between items-center mb-6'>
                <h1 className="text-2xl font-bold text-gray-800">{t("setting.generalSettings")}</h1>
                {loading ? <MwSpinnerButton /> : <MwButton
                    inGroup={true}
                    size='sm'
                    onClick={saveHandler}
                    type='saveBtn'
                >
                    {t("setting.Save_changes")}
                </MwButton>}
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                {generalSettingList}
            </div>
        </div>
    )
}

export default GeneralSettings
